/* tslint:disable */
/* eslint-disable */
export enum MerchantEventOrderByEnum {
  Id = 'Id',
  CreatedUtc = 'CreatedUtc',
  EventType = 'EventType'
}
